import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['builder']

  static FIELD_METADATA = {
    'transaction_type': {
      type: 'select',
      options: [
        { value: 'rent', label: 'Locação' },
        { value: 'sale', label: 'Venda' }
      ]
    },
    'intended_transaction_type': {
      type: 'select',
      options: [
        { value: 'sale', label: 'Venda' },
        { value: 'rent', label: 'Locação' },
        { value: 'listing_request', label: 'Captação' }
      ]
    },
    'offer_type': {
      type: 'select',
      options: [
        { value: 'broker_partnership', label: 'Corretor propondo parceria' },
        { value: 'service_provider', label: 'Prestador de serviço' },
        { value: 'job_seeker', label: 'Candidato a vaga de emprego' },
        { value: 'listing_removal', label: 'Pedido de retirada de anúncio' }
      ],
      presenceLabels: {
        blank: 'É cliente comum (buscando imóvel)',
        present: 'Não é cliente (parceria, prestador, vaga ou retirada de anúncio)'
      }
    },
    'usage_type': {
      type: 'select',
      options: [
        { value: 'residential', label: 'Residencial' },
        { value: 'commercial', label: 'Comercial' }
      ]
    },
    'credit_state': {
      type: 'select',
      options: [
        { value: '0', label: 'Pendente' },
        { value: '1', label: 'Plaza Green' },
        { value: '2', label: 'Plaza Red' },
        { value: '3', label: 'Plaza Yellow' },
        { value: '4', label: 'Arquivado' },
        { value: '5', label: 'Sem documento' },
        { value: '6', label: 'Não se aplica' }
      ]
    },
    'stage': {
      type: 'select',
      options: [
        { value: 'conversation_started', label: 'Conversa iniciada' },
        { value: 'visit_scheduled', label: 'Visita agendada' },
        { value: 'qualified', label: 'Qualificado' }
      ]
    },
    'property_acquisition_desired_transaction': {
      type: 'select',
      options: [
        { value: 'rent', label: 'Locação' },
        { value: 'sale', label: 'Venda' },
        { value: 'exchange', label: 'Permuta' }
      ]
    },
    'property_acquisition_city': { type: 'text' },
    'authenticated_user_role': {
      type: 'select',
      options: [
        { value: 'owner', label: 'Proprietário' },
        { value: 'tenant', label: 'Inquilino' }
      ]
    },
    'authenticated_at': {
      type: 'text',
      presenceOnly: true
    },
    'conversation.user_replied?': { type: 'boolean' },
    'user_sent_first_message?': { type: 'boolean' },
    'listing.development': { type: 'boolean' },
    'listing.exclusive?': { type: 'boolean' },
    'property_acquisition?': { type: 'boolean' },
    'human_requested?': { type: 'boolean' },
    'conversation_user.profile.relationship_signals': {
      type: 'select',
      options: [
        { value: 'at_risk', label: 'Em risco' },
        { value: 'frustrated', label: 'Frustrado' },
        { value: 'neutral', label: 'Neutro' },
        { value: 'satisfied', label: 'Satisfeito' },
        { value: 'promoter', label: 'Promotor' }
      ]
    },
    'forced_qualification': { type: 'boolean' },
    'high_priority': { type: 'boolean' },
    'unknown_answer': { type: 'boolean' },
    'manual_qualification': { type: 'boolean' },
    'contract_active?': { type: 'boolean' },
    'started_by_operator?': { type: 'boolean' },
    'closed_after_handoff?': { type: 'boolean' },
    'user_messages_count': { type: 'number' },
    'conversion_rank': { type: 'number' },
    'max_billing_overdue_days': { type: 'number' },
    'listing.list_price': { type: 'number' },
    'listing.rental_price': { type: 'number' },
    'listing.location.area': { type: 'text' },
    'listing.location.neighborhood': { type: 'text' },
    'listing.location.complex_name': { type: 'text' },
    'listing.location.city': { type: 'text' },
    'listing.crm_data.agency_slug': { type: 'text' },
    'listing.bedrooms': { type: 'number' },
    'listing.bathrooms': { type: 'number' },
    'listing.parking_spaces': { type: 'number' },
    'listing.property_type': {
      type: 'select',
      options: [
        { value: 'casa', label: 'Casa' },
        { value: 'apartamento', label: 'Apartamento' },
        { value: 'sobrado residencial', label: 'Sobrado Residencial' },
        { value: 'cobertura', label: 'Cobertura' },
        { value: 'casa em condominio', label: 'Casa em Condomínio' },
        { value: 'terreno residencial', label: 'Terreno Residencial' },
        { value: 'lote residencial', label: 'Lote Residencial' },
        { value: 'studio', label: 'Studio' },
        { value: 'kitnet', label: 'Kitnet' },
        { value: 'chacara', label: 'Chácara' },
        { value: 'sitio', label: 'Sítio' },
        { value: 'fazenda', label: 'Fazenda' },
        { value: 'galpao', label: 'Galpão' },
        { value: 'sala comercial', label: 'Sala Comercial' },
        { value: 'conjunto de salas', label: 'Conjunto de Salas' },
        { value: 'predio inteiro', label: 'Prédio Inteiro' },
        { value: 'loja', label: 'Loja' },
        { value: 'salao comercial', label: 'Salão Comercial' },
        { value: 'ponto comercial', label: 'Ponto Comercial' },
        { value: 'terreno comercial', label: 'Terreno Comercial' },
        { value: 'lote comercial', label: 'Lote Comercial' },
        { value: 'deposito', label: 'Depósito' },
        { value: 'armazem', label: 'Armazém' },
        { value: 'box', label: 'Box' },
        { value: 'casa comercial', label: 'Casa Comercial' },
        { value: 'empreendimento', label: 'Empreendimento' }
      ]
    }
  }

  connect() {
    this.conditionIndex = this.getNextConditionIndex()
    const modalBox = this.element.querySelector('[data-rotation-type]') || this.element
    this.rotationType = modalBox?.dataset?.rotationType || 'standard'
    this.paramKey = modalBox?.dataset?.paramKey ||
      (this.rotationType === 'support' ? 'support_assignment_rotation' : 'lead_assignment_rotation')
    this.dynamicFieldOptions = this.parseDynamicFieldOptions(modalBox)
    this.updateFieldListeners()
    this.hydrateExistingConditions(modalBox)
  }

  // Server emits saved conditions as data-existing-conditions JSON on the
  // hidden config div. We replay each one through the same primitives the
  // "+ Adicionar filtro" button uses, then set the saved field/operator/value
  // and add a hidden id input so accepts_nested_attributes_for updates them
  // in place instead of creating duplicates.
  hydrateExistingConditions(modalBox) {
    const json = modalBox?.dataset?.existingConditions
    if (!json) return

    let conditions
    try { conditions = JSON.parse(json) } catch { return }
    if (!Array.isArray(conditions) || conditions.length === 0) return

    const builder = this.builderTarget

    conditions.forEach((cond) => {
      this.addRootCondition()
      const groups = builder.querySelectorAll('.condition-group')
      const group = groups[groups.length - 1]
      if (!group) return

      const idInput = document.createElement('input')
      idInput.type = 'hidden'
      idInput.name = `${this.paramKey}[conditions_attributes][${group.dataset.conditionIndex}][id]`
      idInput.value = cond.id
      group.prepend(idInput)

      const fieldSelect = group.querySelector('select[name$="[field]"]')
      if (!fieldSelect || !cond.field) return
      fieldSelect.value = cond.field

      const operatorSelect = group.querySelector('select[name$="[operator]"]')
      if (operatorSelect) {
        this.rebuildOperatorSelect(operatorSelect, cond.field)
        operatorSelect.value = cond.operator || ''
      }

      const valueContainer = group.querySelector('.value-input-container') ||
                             group.querySelector('[data-condition-value]')?.closest('div')
      if (valueContainer) {
        this.rebuildValueInput(valueContainer, cond.field, cond.value, cond.operator)
      }
    })
  }

  parseDynamicFieldOptions(modalBox) {
    const json = modalBox?.dataset?.dynamicFieldOptions
    if (!json) return {}

    try {
      const parsed = JSON.parse(json)
      const result = {}
      for (const [field, options] of Object.entries(parsed)) {
        result[field] = { type: 'select', options, restrictedOperators: true }
      }
      return result
    } catch {
      return {}
    }
  }

  getNextConditionIndex() {
    const builder = this.builderTarget
    const conditionGroups = builder.querySelectorAll('.condition-group')
    let maxIndex = -1

    conditionGroups.forEach(group => {
      const orderIndexInput = group.querySelector('input[name$="[order_index]"]')
      if (orderIndexInput) {
        const match = orderIndexInput.name.match(/\[conditions_attributes\]\[(\d+)\]/)
        if (match) {
          const index = parseInt(match[1], 10)
          if (index > maxIndex) maxIndex = index
        }
      }
    })

    return maxIndex + 1
  }

  getNextChildIndex(container, attributesName) {
    const children = container.querySelectorAll('.condition-child')
    let maxIndex = -1

    children.forEach(child => {
      const orderIndexInput = child.querySelector('input[name$="[order_index]"]')
      if (orderIndexInput) {
        const regex = new RegExp(`\\[${attributesName}\\]\\[(\\d+)\\]`)
        const match = orderIndexInput.name.match(regex)
        if (match) {
          const index = parseInt(match[1], 10)
          if (index > maxIndex) maxIndex = index
        }
      }
    })

    return maxIndex + 1
  }

  open(event) {
    event?.preventDefault()
    const modal = document.getElementById('conditions_modal')
    if (modal) modal.showModal()
  }

  close() {
    const modal = document.getElementById('conditions_modal')
    if (modal) modal.close()
  }

  closeOnBackdrop(event) {
    const modal = document.getElementById('conditions_modal')
    if (event.target === modal) this.close()
  }

  addRootCondition(event) {
    event?.preventDefault()

    const builder = this.builderTarget
    const visibleConditions = Array.from(builder.querySelectorAll('.condition-group')).filter(
      el => el.style.display !== 'none'
    )

    const newIndex = this.conditionIndex
    this.conditionIndex++

    let htmlToInsert = ''
    if (visibleConditions.length > 0) {
      htmlToInsert += `
        <div class="flex items-center gap-3 py-2 and-separator">
          <div class="flex-1 h-px bg-gray-300"></div>
          <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide">E</span>
          <div class="flex-1 h-px bg-gray-300"></div>
        </div>
      `
    }

    htmlToInsert += this.createConditionElement(
      newIndex,
      0,
      `${this.paramKey}[conditions_attributes][${newIndex}]`
    )

    const addButtonContainer = builder.querySelector('[data-add-root-button-container]')
    if (addButtonContainer) {
      addButtonContainer.insertAdjacentHTML('beforebegin', htmlToInsert)
    } else {
      builder.insertAdjacentHTML('beforeend', htmlToInsert)
    }

    this.updateFieldListeners()
  }

  addAndCondition(event) {
    event?.preventDefault()

    const conditionGroup = event.currentTarget.closest('.condition-group')
    const conditionChild = event.currentTarget.closest('.condition-child')
    const parentCondition = conditionChild || conditionGroup

    if (!parentCondition) return

    const currentLevel = parseInt(parentCondition.dataset.level || '0')
    if (currentLevel >= 2) return

    let andSection = parentCondition.querySelector('[data-operator="and"]')
    if (!andSection) {
      const andHTML = `
        <div class="ml-4 mt-3 pl-4 border-l-2 border-green-300 space-y-3" data-operator="and">
          <div class="flex items-center gap-2">
            <span class="text-xs font-semibold text-green-700 uppercase tracking-wide">E (AND)</span>
          </div>
          <div class="and-conditions-container space-y-3"></div>
        </div>
      `
      parentCondition.insertAdjacentHTML('beforeend', andHTML)
      andSection = parentCondition.querySelector('[data-operator="and"]')
    }

    const container = andSection.querySelector('.and-conditions-container')
    const andConditionsIndex = this.getNextChildIndex(container, 'and_conditions_attributes')
    const parentPrefix = this.getConditionPrefix(parentCondition)
    const newPrefix = `${parentPrefix}[and_conditions_attributes][${andConditionsIndex}]`
    const newLevel = currentLevel + 1

    const newCondition = this.createChildConditionElement(andConditionsIndex, newPrefix, newLevel, 'and')
    container.insertAdjacentHTML('beforeend', newCondition)
    this.updateFieldListeners()
  }

  addOrCondition(event) {
    event?.preventDefault()

    const conditionGroup = event.currentTarget.closest('.condition-group')
    const conditionChild = event.currentTarget.closest('.condition-child')
    const parentCondition = conditionChild || conditionGroup

    if (!parentCondition) return

    const currentLevel = parseInt(parentCondition.dataset.level || '0')
    if (currentLevel >= 2) return

    let orSection = parentCondition.querySelector('[data-operator="or"]')
    if (!orSection) {
      const orHTML = `
        <div class="ml-4 mt-3 pl-4 border-l-2 border-orange-300 space-y-3" data-operator="or">
          <div class="flex items-center gap-2">
            <span class="text-xs font-semibold text-orange-700 uppercase tracking-wide">OU (OR)</span>
          </div>
          <div class="or-conditions-container space-y-3"></div>
        </div>
      `
      parentCondition.insertAdjacentHTML('beforeend', orHTML)
      orSection = parentCondition.querySelector('[data-operator="or"]')
    }

    const container = orSection.querySelector('.or-conditions-container')
    const orConditionsIndex = this.getNextChildIndex(container, 'or_conditions_attributes')
    const parentPrefix = this.getConditionPrefix(parentCondition)
    const newPrefix = `${parentPrefix}[or_conditions_attributes][${orConditionsIndex}]`
    const newLevel = currentLevel + 1

    const newCondition = this.createChildConditionElement(orConditionsIndex, newPrefix, newLevel, 'or')
    container.insertAdjacentHTML('beforeend', newCondition)
    this.updateFieldListeners()
  }

  removeCondition(event) {
    event?.preventDefault()
    const button = event.currentTarget
    const conditionElement = button.closest('.condition-group, .condition-child')

    if (!conditionElement) return

    const isRootCondition = conditionElement.classList.contains('condition-group')

    if (isRootCondition) {
      const previousElement = conditionElement.previousElementSibling
      if (previousElement?.classList?.contains('and-separator')) {
        previousElement.remove()
      } else {
        const nextElement = conditionElement.nextElementSibling
        if (nextElement?.classList?.contains('and-separator')) {
          nextElement.remove()
        }
      }
    }

    const idInput = conditionElement.querySelector('input[name$="[id]"]')
    const hasPersistedId = idInput && idInput.value && idInput.value.trim() !== ''

    if (hasPersistedId) {
      const prefix = this.getConditionPrefix(conditionElement)
      const form = conditionElement.closest('form')

      const destroyInput = document.createElement('input')
      destroyInput.type = 'hidden'
      destroyInput.name = `${prefix}[_destroy]`
      destroyInput.value = '1'
      form.appendChild(destroyInput)

      const idHidden = document.createElement('input')
      idHidden.type = 'hidden'
      idHidden.name = `${prefix}[id]`
      idHidden.value = idInput.value
      form.appendChild(idHidden)
    }

    conditionElement.remove()
    this.cleanupEmptySections()
  }

  cleanupEmptySections() {
    const builder = this.builderTarget
    const sections = builder.querySelectorAll('[data-operator="and"], [data-operator="or"]')

    sections.forEach(section => {
      const container = section.querySelector('.and-conditions-container, .or-conditions-container')
      const visibleChildren = Array.from(container?.children || []).filter(child =>
        child.style.display !== 'none'
      )
      if (visibleChildren.length === 0) {
        section.remove()
      }
    })
  }

  buildSelectInput(inputName, options, currentValue) {
    const optionsHTML = options.map(opt =>
      `<option value="${opt.value}" ${opt.value === currentValue ? 'selected' : ''}>${opt.label}</option>`
    ).join('')

    return `
      <select name="${inputName}" data-condition-value class="select select-bordered w-full bg-white h-10 min-h-10">
        <option value="">Selecione...</option>
        ${optionsHTML}
      </select>
    `
  }

  buildBooleanInput(inputName, currentValue) {
    const trueChecked = currentValue === 'true' || currentValue === true ? 'checked' : ''
    const falseChecked = currentValue === 'false' || currentValue === false ? 'checked' : ''

    return `
      <div class="flex items-center gap-6">
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="${inputName}" value="true" data-condition-value class="radio" ${trueChecked} />
          <span class="text-sm text-gray-700">Sim</span>
        </label>
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="${inputName}" value="false" data-condition-value class="radio" ${falseChecked} />
          <span class="text-sm text-gray-700">Não</span>
        </label>
      </div>
    `
  }

  buildNumberInput(inputName, currentValue) {
    return `
      <input type="number" name="${inputName}" value="${currentValue || ''}" data-condition-value
        class="input input-bordered w-full bg-white h-10 min-h-10" placeholder="Digite um número..." />
    `
  }

  buildTextInput(inputName, currentValue) {
    return `
      <input type="text" name="${inputName}" value="${currentValue || ''}" data-condition-value
        class="input input-bordered w-full bg-white h-10 min-h-10" placeholder="Digite o valor..." />
    `
  }

  rebuildValueInput(container, field, currentValue, operator) {
    if (operator === 'present' || operator === 'blank') {
      const existingInput = container.querySelector('[data-condition-value]')
      if (existingInput) container.dataset.savedInputName = existingInput.name
      container.innerHTML = ''
      container.classList.add('hidden')
      return
    }

    container.classList.remove('hidden')

    const metadata = this.getFieldMetadata(field)
    const existingInput = container.querySelector('[data-condition-value]')
    let inputName = existingInput?.name || container.dataset.savedInputName

    if (!inputName) {
      const conditionItem = container.closest('.condition-group, .condition-child')
      if (conditionItem) {
        const prefix = this.getConditionPrefix(conditionItem)
        inputName = `${prefix}[value]`
      }
    }

    let newInputHTML = ''

    switch(metadata.type) {
      case 'select':
        newInputHTML = this.buildSelectInput(inputName, metadata.options, currentValue)
        break
      case 'boolean':
        newInputHTML = this.buildBooleanInput(inputName, currentValue)
        break
      case 'number':
        newInputHTML = this.buildNumberInput(inputName, currentValue)
        break
      default:
        newInputHTML = this.buildTextInput(inputName, currentValue)
    }

    container.innerHTML = newInputHTML
  }

  updateField(event) {
    const select = event.target
    const field = select.value
    const conditionItem = select.closest('.condition-group, .condition-child')

    if (!conditionItem) return

    const operatorSelect = conditionItem.querySelector('select[name$="[operator]"]')
    let valueContainer = conditionItem.querySelector('.value-input-container')

    if (!valueContainer) {
      const valueInput = conditionItem.querySelector('[data-condition-value]')
      valueContainer = valueInput?.closest('div')
    }

    if (operatorSelect) {
      this.rebuildOperatorSelect(operatorSelect, field)
      operatorSelect.selectedIndex = 0
    }
    if (valueContainer) this.rebuildValueInput(valueContainer, field, null, '')
  }

  rebuildOperatorSelect(operatorSelect, field) {
    const meta = this.getFieldMetadata(field)
    const dynamicMeta = this.dynamicFieldOptions[field]
    const restricted = dynamicMeta?.restrictedOperators

    if (meta.presenceLabels) {
      operatorSelect.innerHTML = `
        <option value="">Selecione uma condição...</option>
        <optgroup label="Cliente ou não">
          <option value="blank">${meta.presenceLabels.blank}</option>
          <option value="present">${meta.presenceLabels.present}</option>
        </optgroup>
        <optgroup label="Tipo específico">
          <option value="equals">= É exatamente</option>
          <option value="not_equals">≠ É qualquer um, exceto</option>
        </optgroup>
      `
    } else if (meta.presenceOnly) {
      operatorSelect.innerHTML = `
        <option value="">Selecione uma condição...</option>
        <optgroup label="Presença">
          <option value="present">✓ Tem valor</option>
          <option value="blank">∅ Está vazio</option>
        </optgroup>
      `
    } else if (meta.type === 'boolean') {
      operatorSelect.innerHTML = `
        <option value="">Selecione uma condição...</option>
        <optgroup label="Valor">
          <option value="equals">= É igual a</option>
        </optgroup>
      `
    } else if (restricted) {
      operatorSelect.innerHTML = `
        <option value="">Selecione uma condição...</option>
        <optgroup label="Comparação">
          <option value="equals">= É igual a</option>
          <option value="not_equals">≠ É diferente de</option>
        </optgroup>
      `
    } else {
      operatorSelect.innerHTML = this.buildFullOperatorOptions()
    }
  }

  // Engagement-pipeline-specific field metadata. EngagementPipeline::Filters::*
  // return true/false for the boolean entries (Sim/Não radios, operator locked
  // to equals) and integers for the `days_since_*` ones (numeric input, full
  // comparison operators).
  getFieldMetadata(field) {
    if (field === 'paused' ||
        field === 'user_replied' ||
        field === 'delivered_to_customer' ||
        field === 'last_outbound_failed' ||
        field === 'lead.visit_date_time' ||
        field.startsWith('lead.crm_log.')) {
      return { type: 'boolean' }
    }
    if (field === 'days_since_last_user_message' ||
        field === 'days_since_created' ||
        field === 'lead.days_since_visit_date_time' ||
        field === 'current_context.context.listing.rental_price') {
      return { type: 'number' }
    }
    return this.dynamicFieldOptions[field] || this.constructor.FIELD_METADATA[field] || { type: 'text' }
  }

  buildFullOperatorOptions() {
    return `
      <option value="">Selecione uma condição...</option>
      <optgroup label="Comparação">
        <option value="equals">= É igual a</option>
        <option value="not_equals">≠ É diferente de</option>
      </optgroup>
      <optgroup label="Texto">
        <option value="contains">⊃ Contém</option>
        <option value="not_contains">⊅ Não contém</option>
        <option value="contains_any">⊃ Contém qualquer um</option>
        <option value="starts_with">⇥ Começa com</option>
        <option value="ends_with">⇤ Termina com</option>
      </optgroup>
      <optgroup label="Lista">
        <option value="in">∈ Está na lista</option>
        <option value="not_in">∉ Não está na lista</option>
      </optgroup>
      <optgroup label="Presença">
        <option value="present">✓ Tem valor</option>
        <option value="blank">∅ Está vazio</option>
      </optgroup>
      <optgroup label="Número">
        <option value="greater_than">> É maior que</option>
        <option value="greater_than_or_equal">≥ É maior ou igual a</option>
        <option value="less_than">< É menor que</option>
        <option value="less_than_or_equal">≤ É menor ou igual a</option>
      </optgroup>
    `
  }

  updateOperator(event) {
    const select = event.target
    const operator = select.value
    const conditionItem = select.closest('.condition-group, .condition-child')

    if (!conditionItem) return

    const fieldSelect = conditionItem.querySelector('select[name$="[field]"]')
    let valueContainer = conditionItem.querySelector('.value-input-container')

    if (!valueContainer) {
      const valueInput = conditionItem.querySelector('[data-condition-value]')
      valueContainer = valueInput?.closest('div')
    }

    if (valueContainer && fieldSelect) {
      const field = fieldSelect.value
      const currentValue = this.getCurrentValue(valueContainer)
      this.rebuildValueInput(valueContainer, field, currentValue, operator)
    }
  }

  getCurrentValue(container) {
    const input = container.querySelector('[data-condition-value]')
    if (!input) return null

    if (input.type === 'radio') {
      const checked = container.querySelector('[data-condition-value]:checked')
      return checked ? checked.value : null
    }

    return input.value
  }

  getConditionPrefix(conditionElement) {
    const idInput = conditionElement.querySelector('input[name$="[id]"]')
    if (idInput) {
      const name = idInput.name
      return name.substring(0, name.lastIndexOf('['))
    }

    const orderIndexInput = conditionElement.querySelector('input[name$="[order_index]"]')
    if (orderIndexInput) {
      const name = orderIndexInput.name
      return name.substring(0, name.lastIndexOf('['))
    }

    return ''
  }

  createFieldInputs(prefix) {
    let fieldOptions
    switch(this.rotationType) {
      case 'property_acquisition':
        fieldOptions = this.getPropertyAcquisitionFieldOptions()
        break
      case 'support':
        fieldOptions = this.getSupportFieldOptions()
        break
      case 'engagement':
        fieldOptions = this.getEngagementFieldOptions()
        break
      default:
        fieldOptions = this.getStandardFieldOptions()
    }

    return `
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Campo</label>
        <select name="${prefix}[field]" class="select select-bordered w-full bg-white h-10 min-h-10" data-action="change->rotation-conditions#updateField">
          <option value="">Selecione um campo...</option>
          ${fieldOptions}
        </select>
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Condição</label>
        <select name="${prefix}[operator]" class="select select-bordered w-full bg-white h-10 min-h-10" data-action="change->rotation-conditions#updateOperator">
          <option value="">Selecione uma condição...</option>
          <optgroup label="Comparação">
            <option value="equals">= É igual a</option>
            <option value="not_equals">≠ É diferente de</option>
          </optgroup>
          <optgroup label="Texto">
            <option value="contains">⊃ Contém</option>
            <option value="not_contains">⊅ Não contém</option>
            <option value="contains_any">⊃ Contém qualquer um</option>
            <option value="starts_with">⇥ Começa com</option>
            <option value="ends_with">⇤ Termina com</option>
          </optgroup>
          <optgroup label="Lista">
            <option value="in">∈ Está na lista</option>
            <option value="not_in">∉ Não está na lista</option>
          </optgroup>
          <optgroup label="Presença">
            <option value="present">✓ Tem valor</option>
            <option value="blank">∅ Está vazio</option>
          </optgroup>
          <optgroup label="Número">
            <option value="greater_than">> É maior que</option>
            <option value="greater_than_or_equal">≥ É maior ou igual a</option>
            <option value="less_than">< É menor que</option>
            <option value="less_than_or_equal">≤ É menor ou igual a</option>
          </optgroup>
        </select>
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Valor</label>
        <div class="value-input-container">
          <input type="text" name="${prefix}[value]" placeholder="Digite o valor..." class="input input-bordered w-full bg-white h-10 min-h-10" data-condition-value>
        </div>
      </div>
    `
  }

  getStandardFieldOptions() {
    return `
      <optgroup label="Lead">
        <option value="origin_domain">Domínio de origem</option>
        <option value="title">Título</option>
        <option value="name">Nome</option>
        <option value="phone">Telefone</option>
        <option value="email">Email</option>
        <option value="usage_type">Tipo de uso</option>
        <option value="transaction_type">Tipo de transação</option>
        <option value="intended_transaction_type">Tipo de transação informada</option>
        <option value="offer_type">Natureza do contato</option>
        <option value="user_messages_count">Nº de mensagens</option>
        <option value="conversion_rank">Chance de fechar (0 a 99)</option>
        <option value="human_requested?">Humano solicitado</option>
        <option value="conversation_user.profile.relationship_signals">Relacionamento (perfil da IA)</option>
        <option value="forced_qualification">Qualificação forçada por tempo</option>
        <option value="high_priority">Alta prioridade</option>
        <option value="unknown_answer">Qualificação por pergunta desconhecida</option>
        <option value="manual_qualification">Qualificação manual</option>
        <option value="rotation_tag">Tag da roleta</option>
      </optgroup>
      <optgroup label="Conversa">
        <option value="conversation.user_replied?">Usuário respondeu</option>
        <option value="agent_phone">Número do agente (WhatsApp)</option>
      </optgroup>
      <optgroup label="Imóvel">
        <option value="listing.property_type">Tipo de imóvel</option>
        <option value="listing.development">É lançamento</option>
        <option value="listing.exclusive?">Possui exclusividade (Inforce)</option>
        <option value="listing.list_price">Preço de venda</option>
        <option value="listing.rental_price">Preço de aluguel</option>
        <option value="listing.location.area">Zona/Área</option>
        <option value="listing.location.neighborhood">Bairro</option>
        <option value="listing.location.complex_name">Nome do condomínio</option>
        <option value="listing.location.city">Cidade</option>
        <option value="listing.crm_data.agency_slug">Agência (filial)</option>
        <option value="listing.crm_id">CRM ID</option>
      </optgroup>
    `
  }

  getSupportFieldOptions() {
    return `
      <optgroup label="Conversa">
        <option value="ticket_category.label">Categoria do ticket</option>
        <option value="ticket_subcategory.name">Subcategoria do ticket</option>
        <option value="authenticated_user_role">Perfil do usuário</option>
        <option value="started_by_operator?">Iniciada por operador</option>
        <option value="closed_after_handoff?">Encerrada após repasse a humano</option>
        <option value="contract_active?">Possui contrato ativo</option>
        <option value="contract_status">Status do contrato selecionado</option>
        <option value="retained_attendant.email">Atendente anterior do chamado</option>
        <option value="metadata.erp_contract.carteira">Carteira (ERP)</option>
        <option value="authenticated_at">Data de autenticação</option>
        <option value="agent_phone">Número do agente (WhatsApp)</option>
      </optgroup>
      <optgroup label="Imóvel">
        <option value="property_city">Cidade do imóvel</option>
        <option value="property_state">Estado do imóvel</option>
        <option value="property_neighborhood">Bairro do imóvel</option>
      </optgroup>
      <optgroup label="Financeiro">
        <option value="billing_statuses">Status do boleto</option>
        <option value="max_billing_overdue_days">Dias de atraso do boleto</option>
      </optgroup>
      <optgroup label="Cliente">
        <option value="conversation_user.phone">Telefone do cliente</option>
      </optgroup>
    `
  }

  getPropertyAcquisitionFieldOptions() {
    return `
      <optgroup label="Lead">
        <option value="origin_domain">Domínio de origem</option>
        <option value="name">Nome</option>
        <option value="phone">Telefone</option>
        <option value="email">Email</option>
        <option value="user_messages_count">Nº de mensagens</option>
      </optgroup>
      <optgroup label="Captação">
        <option value="property_acquisition_desired_transaction">Tipo de captação</option>
        <option value="property_acquisition_city">Cidade da captação</option>
      </optgroup>
      <optgroup label="Conversa">
        <option value="conversation.user_replied?">Usuário respondeu</option>
        <option value="agent_phone">Número do agente (WhatsApp)</option>
      </optgroup>
    `
  }

  getEngagementFieldOptions() {
    const crmOptions = this.getEngagementCrms()
      .map(c => `<option value="lead.crm_log.${c.slug}">Enviado ao CRM (${c.name})</option>`)
      .join('')

    return `
      <optgroup label="Conversa">
        <option value="paused">Conversa pausada</option>
        <option value="user_replied">Cliente já respondeu</option>
        <option value="delivered_to_customer">Mensagem entregue ao cliente</option>
        <option value="last_outbound_failed">Último envio falhou (não entregue)</option>
        <option value="days_since_last_user_message">Dias desde a última mensagem do cliente</option>
        <option value="days_since_created">Dias desde criação da conversa</option>
        <option value="agent_phone">Número do agente (WhatsApp)</option>
      </optgroup>
      <optgroup label="Cliente">
        <option value="conversation_user.phone">Telefone</option>
        <option value="conversation_user.email">E-mail</option>
      </optgroup>
      <optgroup label="Imóvel & Interesse">
        <option value="current_context.context.transaction_type">Tipo de transação (venda/locação)</option>
        <option value="current_context.context.usage_type">Tipo de uso (residencial/comercial)</option>
        <option value="current_context.context.listing.crm_id">Código do imóvel (CRM)</option>
        <option value="current_context.context.listing.rental_price">Valor do aluguel (R$)</option>
      </optgroup>
      <optgroup label="Lead">
        <option value="lead.visit_date_time">Visita agendada</option>
        <option value="lead.days_since_visit_date_time">Dias desde a visita marcada</option>
        ${crmOptions}
      </optgroup>
    `
  }

  getEngagementCrms() {
    try {
      const raw = this.element.querySelector('[data-engagement-crms]')?.dataset?.engagementCrms
      return raw ? JSON.parse(raw) : []
    } catch {
      return []
    }
  }

  createConditionElement(index, level, prefix) {
    const canHaveChildren = level < 2

    const actionButtons = canHaveChildren ? `
      <div class="flex items-center gap-2 mt-3 pt-3 border-t border-gray-200">
        <button type="button" class="text-xs text-green-700 hover:text-green-900 cursor-pointer"
          data-action="rotation-conditions#addAndCondition" data-condition-index="${index}">+ Adicionar E (AND)</button>
        <span class="text-gray-300">|</span>
        <button type="button" class="text-xs text-orange-700 hover:text-orange-900 cursor-pointer"
          data-action="rotation-conditions#addOrCondition" data-condition-index="${index}">+ Adicionar OU (OR)</button>
      </div>
    ` : ''

    return `
      <div class="condition-group" data-condition-index="${index}" data-level="${level}">
        <input type="hidden" name="${prefix}[order_index]" value="${index}">
        <div class="bg-gray-50 border border-gray-200 rounded p-4">
          <div class="flex items-center justify-between mb-3">
            <span class="text-xs font-medium text-gray-500">Regra ${index + 1}</span>
            <button type="button" class="text-gray-400 hover:text-red-600 cursor-pointer"
              data-action="rotation-conditions#removeCondition" data-condition-index="${index}" title="Remover regra">×</button>
          </div>
          <div class="space-y-3">
            ${this.createFieldInputs(prefix)}
          </div>
          ${actionButtons}
        </div>
      </div>
    `
  }

  createChildConditionElement(index, prefix, level, parentOp) {
    const canHaveChildren = level < 2

    const actionButtons = canHaveChildren ? `
      <div class="flex items-center gap-2 mt-3 pt-3 border-t border-gray-200">
        <button type="button" class="text-xs text-green-700 hover:text-green-900 cursor-pointer"
          data-action="rotation-conditions#addAndCondition" data-condition-index="${index}">+ Adicionar E (AND)</button>
        <span class="text-gray-300">|</span>
        <button type="button" class="text-xs text-orange-700 hover:text-orange-900 cursor-pointer"
          data-action="rotation-conditions#addOrCondition" data-condition-index="${index}">+ Adicionar OU (OR)</button>
      </div>
    ` : ''

    return `
      <div class="condition-child" data-condition-index="${index}" data-level="${level}">
        <input type="hidden" name="${prefix}[order_index]" value="${index}">
        <input type="hidden" name="${prefix}[parent_operator]" value="${parentOp}">
        <div class="bg-gray-50 border border-gray-200 rounded p-4">
          <div class="flex items-center justify-between mb-3">
            <span class="text-xs font-medium text-gray-500">Regra ${index + 1}</span>
            <button type="button" class="text-gray-400 hover:text-red-600 cursor-pointer"
              data-action="rotation-conditions#removeCondition" data-condition-index="${index}" title="Remover regra">×</button>
          </div>
          <div class="space-y-3">
            ${this.createFieldInputs(prefix)}
          </div>
          ${actionButtons}
        </div>
      </div>
    `
  }

  updateFieldListeners() {
    const fieldSelects = this.element.querySelectorAll('select[name$="[field]"]')
    fieldSelects.forEach(select => {
      if (!select.dataset.listenerAdded) {
        select.addEventListener('change', this.updateField.bind(this))
        select.dataset.listenerAdded = 'true'
      }
    })

    const operatorSelects = this.element.querySelectorAll('select[name$="[operator]"]')
    operatorSelects.forEach(select => {
      if (!select.dataset.listenerAdded) {
        select.addEventListener('change', this.updateOperator.bind(this))
        select.dataset.listenerAdded = 'true'
      }
    })
  }
}
